module.exports = __webpack_public_path__ + "static/UnifyHero-fd91146d099bdd4b0d7b6d2e047abae8.svg";